import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {
  BasketItem,
  EnterpriseSearchService,
  ServiceType,
  CarHireType
} from '@sabstravtech/obtservices/angular';

@Component({
  selector: 'app-basket-car-hire',
  templateUrl: './basket-car-hire.component.html',
  styleUrls: ['./basket-car-hire.component.scss'],
  standalone: false
})
export class BasketCarHireComponent implements OnInit {
  @Input() hideIcon = false;
  @Input() car: BasketItem;
  @Input() duplicateBooking = false;
  @Output() remove: EventEmitter<void> = new EventEmitter<void>();
  @Output() openChangeModal: EventEmitter<void> = new EventEmitter<void>();
  @Input() displayItinerary = false;
  travellers = [];
  carTypeCodes: [string, string, CarHireType][];
  displayHeading: string;

  constructor(private searchService: EnterpriseSearchService) {}

  ngOnInit(): void {
    this.travellers = [...(this.car?.users || []), ...(this.car?.guests || [])];
    this.carTypeCodes = this.searchService.searches[ServiceType.Car].carTypeCodes;
    this.displayHeading = this.getDisplayHeading();
  }

  getDisplayHeading(): string {
    const detail = this.car?.detail;
    if (!detail?.car) {
      return '';
    }
    const vehicleClass = detail.car.class;
    const vehicleType = detail.car.type;
    const typeCode = this.carTypeCodes?.find((code) => code[2] === vehicleType);
    const typeDisplay = typeCode ? typeCode[1] : vehicleType;
    return `${vehicleClass} ${typeDisplay}`;
  }
}
